import { cn } from 'common/utils';
import { useMounted } from 'common/utils/hooks/useDidMount';
import OverlaySkeleton from 'components/v2/atoms/overlay-skeleton';
import ActionSection from 'components/v2/molecules/action-section';
import AuthorInfo from 'components/v2/molecules/author-info';
import Breadcrumb from 'components/v2/molecules/breadcrumb';
import ShareSection from 'components/v2/molecules/share-section';
import { ArticleWithContentType } from 'service/article';

import styles from './article.module.scss';

const ArticleContent = ({ article }: { article: ArticleWithContentType }) => {
  const { type, breadcrumbItems, date, content, author, readTime, metadata } =
    article;

  const isMounted = useMounted();
  const authorInfo = {
    name: author.name,
    role: author.jobTitle,
    avatar: author.avatar,
    date: date,
  };

  return (
    <div className="mx-auto max-w-[1000px] p-5 md:p-10">
      {/* Breadcrumb */}
      <Breadcrumb items={breadcrumbItems} />

      {/* Article Info Section */}
      <div className="mb-5 rounded-xl bg-gray-50 p-4 md:mb-10 md:p-5">
        {/* Article Meta */}
        <div className="mb-4 flex items-center gap-4 text-sm text-gray-500">
          <span className="rounded-2xl bg-green-100 px-3 py-1 text-xs font-semibold text-green-600">
            {type}
          </span>
          <span>•</span>
          <span>{readTime}で読める</span>
        </div>

        {/* Author Section */}
        <AuthorInfo author={authorInfo} />
      </div>

      {/* Article Content */}
      <article className={cn('', styles['article-content'])}>
        {isMounted ? (
          <div
            className="max-w-full"
            dangerouslySetInnerHTML={{
              __html: content || 'No content available',
            }}
          />
        ) : (
          <div className="relative max-w-full">
            {/* add a overlay loading */}
            <OverlaySkeleton className="bg-white" />
            <div>{content || 'No content available'}</div>
          </div>
        )}
      </article>

      {/* Call to Action */}
      <ActionSection />

      {/* Share Section */}
      <ShareSection url={metadata.url} text={`${metadata.title}`} />
    </div>
  );
};

export default ArticleContent;
